import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-db07136e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "blog-wrap pt-20 pb-20 bg-albastor" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title style1 text-center mb-40" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Dernières informations de L' École d’Initiation Théologique et Pastorale"),
  /*#__PURE__*/_createElementVNode("h2", null, "Nos derniers articles")
], -1))
const _hoisted_4 = { class: "row justify-content-center" }
const _hoisted_5 = { class: "blog-card style1" }
const _hoisted_6 = {
  class: "blog-img",
  style: {"height":"277px"}
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "blog-info" }
const _hoisted_9 = { class: "blog-metainfo list-style" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-user" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-calendar" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-right-arrow" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.truncatedArticles, (article, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-xl-4 col-lg-6 col-md-6",
            key: index
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("img", {
                  src: _ctx.getUrlApiForFiles(article.urlImage),
                  alt: "Image",
                  style: {"width":"100%","height":"auto","object-fit":"contain"}
                }, null, 8, _hoisted_7)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("ul", _hoisted_9, [
                  _createElementVNode("li", null, [
                    _hoisted_10,
                    _createVNode(_component_router_link, { to: "/posts-by-author" }, {
                      default: _withCtx(() => [
                        _createTextVNode("L' École d’Initiation Théologique et Pastorale")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _hoisted_11,
                    _createTextVNode(_toDisplayString(_ctx.format_date(article.datePublication)), 1)
                  ])
                ]),
                _createElementVNode("h3", null, [
                  _createVNode(_component_router_link, {
                    to: { name: 'ViewArticlePage', params: { id: article.id } }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.truncateText(article.titre,35)), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _createVNode(_component_router_link, {
                  to: { name: 'ViewArticlePage', params: { id: article.id } },
                  class: "link style1"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Lire plus "),
                    _hoisted_12
                  ]),
                  _: 2
                }, 1032, ["to"])
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}